import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { resolveFunnelUrlByMonetizationTest } from '@/helpers';
import { landingImageConverterConfig } from '@/data/landingConfig/landingImageConverterConfig';
import { MONETIZATION_TEST } from '@/constants';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_ImageConverter } from './schemaObject';

interface Props {}
const ImageConverter: React.FC<Props> = () => {
	const funnelUrl = resolveFunnelUrlByMonetizationTest(
		{
			[MONETIZATION_TEST.NON_TIER_1]:
				GenerateLandingLinkService.funnelImageConverterV2,
		},
		GenerateLandingLinkService.funnelImageConverter,
	);
	return (
		<>
			<AggregateSchema schema={schemaObject_ImageConverter} />
			<LandingTemplate
				data={landingImageConverterConfig}
				funnelLinkService={funnelUrl}
			/>
		</>
	);
};

export default ImageConverter;
